export const getComponentHeightInPx = (id: string): number => {
  const element = document.getElementById(id);
  if (element) {
    const headerStyle = window.getComputedStyle(element);
    const headerHeight = headerStyle.getPropertyValue("height");
    return parseInt(headerHeight.replace("px", ""));
  }
  return 0;
};
